/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 17:59:31
 */ 
import {memberHomeEn} from "./memberHome/memberHomeEn.js";
import {memberOrderEn} from "./memberOrder/memberOrderEn.js";
import {memberInquirySheetEn} from "./memberInquirySheet/memberInquirySheetEn.js";
import {MemberTestingProgrammeEn} from "./MemberTestingProgramme/MemberTestingProgrammeEn.js";
import {MemberOrderEvaluationEn} from "./MemberOrderEvaluation/MemberOrderEvaluationEn.js";
import {MemberTrainCourseEn} from "./MemberTrainCourse/MemberTrainCourseEn.js";
import {MemberTrainOrderEn} from "./MemberTrainOrder/MemberTrainOrderEn.js";
import {MemberTrainEvaluationEn} from "./MemberTrainEvaluation/MemberTrainEvaluationEn.js";
import {MyConsultationEn} from "./MyConsultation/MyConsultationEn.js";
import {ConsultationOrderEn} from "./ConsultationOrder/ConsultationOrderEn.js";
import {ConsultationEvaluationEn} from "./ConsultationEvaluation/ConsultationEvaluationEn.js";
import {memberCollectionEn} from "./memberCollection/memberCollectionEn.js";
import {certificateEn} from "./certificate/certificateEn.js";
import {specimenEn} from "./specimen/specimenEn.js";
import {specimenDetailEn} from "./specimenDetail/specimenDetailEn.js";
import {vistedRecordsEn} from "./vistedRecords/vistedRecordsEn.js";
import {modifyMemberInfoEn} from "./modifyMemberInfo/modifyMemberInfoEn.js";
import {integralEn} from "./integral/integralEn.js";
import {AddressBookEn} from "./AddressBook/indexEn.js";
import {InvoiceEn} from "./Invoice/InvoiceEn.js";
export const memberEn = {
    memberHomeLang:memberHomeEn,
    memberOrderLang:memberOrderEn,
    memberInquirySheetLang:memberInquirySheetEn,
    MemberTestingProgrammeLang:MemberTestingProgrammeEn,
    MemberOrderEvaluationLang:MemberOrderEvaluationEn,
    MemberTrainCourseLang:MemberTrainCourseEn,
    MemberTrainOrderLang:MemberTrainOrderEn,
    MemberTrainEvaluationLang:MemberTrainEvaluationEn,
    MyConsultationLang:MyConsultationEn,
    ConsultationOrderLang:ConsultationOrderEn,
    ConsultationEvaluationLang:ConsultationEvaluationEn,
    memberCollectionLang:memberCollectionEn,
    certificateLang:certificateEn,
    specimenLang:specimenEn,
    specimenDetailLang:specimenDetailEn,
    vistedRecordsLang:vistedRecordsEn,
    modifyMemberInfoLang:modifyMemberInfoEn,
    integralLang:integralEn,
    AddressBookLang:AddressBookEn,
    InvoiceLang:InvoiceEn
}


// WEBPACK FOOTER //
// ./src/lang/member/memberEn.js